export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS"
export const UPDATE_ORDER_STATUS_SUCCESSFUL = "UPDATE_ORDER_STATUS_SUCCESSFUL"
export const UPDATE_ORDER_STATUS_FAILED = "UPDATE_ORDER_STATUS_FAILED"
export const UPDATE_ORDER_STATUS_RESET = "UPDATE_ORDER_STATUS_RESET"
